import moment from "moment";
import { VACATION_REQUEST_STATUS_ID } from "../../../configs/constants";

export const isVacationPending = event => {
  return event.type === VACATION_REQUEST_STATUS_ID.PENDING;
};

export const isVacationValidated = event => {
  return event.type === VACATION_REQUEST_STATUS_ID.VALIDATED;
};

export const isVacationRejected = event => {
  return event.type === VACATION_REQUEST_STATUS_ID.REJECTED;
};

export const computeIfIsVacation = event => {
  return isVacationRejected(event) || isVacationValidated(event) || isVacationPending(event);
};

export const isAbsenceRejected = event => {
  return event.type === VACATION_REQUEST_STATUS_ID.REJECTED;
};

export const isAbsenceValidated = event => {
  return event.type === VACATION_REQUEST_STATUS_ID.VALIDATED;
};
export const isAbsencePending = event => {
  return event.type === VACATION_REQUEST_STATUS_ID.PENDING;
};
export const computeIfIsAbsence = event => {
  return isAbsenceRejected(event) || isAbsenceValidated(event) || isAbsencePending(event);
};

export const isDurationLowerThan45Min = event => {
  return (event.end - event.start) / (45 * 60 * 1000) <= 1;
};

export const isPlaned = (event = {}) => {
  const endDate = moment(event.end_date);
  return endDate && endDate.isAfter(new Date()) && !event.visit_id;
};

export const isNotPlanned = (event = {}) => {
  return event.not_planned;
};

export const isVisited = (event = {}) => {
  return !!event.visit_id;
};

export const isNotVisited = (event = {}) => {
  const endDate = moment(event.end_date);
  return endDate && endDate.isBefore(new Date()) && !event.visit_id && !event.not_planned;
};

export const isSpeedyOrAdmin = (event = {}) => {
  return event.event_type_id === 11 || event.event_type_id === 9;
};
export const getMinTime = ({ events = [], defaultMin = "06:00" }) => {
  const minTime = moment.min(
    [
      ...events.map(e => moment(moment().format("YYYY-MM-DD") + " " + moment(e.start).format("HH:mm"))),
      moment(moment().format("YYYY-MM-DD") + " " + defaultMin)
    ].filter(e => e.format("HH:mm") !== "00:00")
  );
  return minTime.format("HH:mm:ss");
};
export const getMaxTime = ({ events = [], defaultMax = "19:00" }) => {
  const maxTime = moment.max(
    [
      ...events.map(e => moment(moment().format("YYYY-MM-DD") + " " + moment(e.end).format("HH:mm"))),
      moment(moment().format("YYYY-MM-DD") + " " + defaultMax)
    ].filter(e => e.format("HH:mm") !== "23:59")
  );
  return maxTime.format("HH:mm:ss");
};



// WEBPACK FOOTER //
// src/containers/activite/planning/Calendar.utils.js